import { BaseDto } from './base.dto';

/**
 * Order Service Type DTO
 */
export class OrderServiceTypeDto extends BaseDto {
  /**
   * Name of the service type.
   * @see {@link OrderServiceTypeNameEnum}
   */
  name: string;

  id:number;
}
